export const LoaderModule = {
	namespaced: true,

	state: {
		running: false,
		text: 'Loader text from loader module'
	},

	actions: {
		show({commit}, text = '') {
			commit('SHOW_LOADER', text);
		},

		hide({commit}) {
			commit('HIDE_LOADER');
		}
	},

	mutations: {
		SHOW_LOADER(state, text) {
			state.running = true;
			if (text !== '') {
				state.text = text;
			}
		},

		HIDE_LOADER(state) {
			state.running = false;
			state.text = 'Loader text from loader module';
		}
	}
};